import { configureStore } from "@reduxjs/toolkit";
import SelectedValues from "./reducers/selectedValues";

function loadFromLocalStorage() {
  try {
    const serializedStore = window.localStorage.getItem("store");
    if (serializedStore === null) return undefined;
    return JSON.parse(serializedStore);
  } catch (e) {
    console.log("error at loadFromLocalStorage===>>> " + e);
    return undefined;
  }
}

const persistedState = loadFromLocalStorage();

export default configureStore(
  {
    reducer: {
      SelectedValues,
    },
    persistedState,
  },
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
